import { setBookingErrorReporter } from '@booking/utils/logger'
import { captureException, captureMessage } from '@sentry/nuxt'

export default defineNuxtPlugin({
  name: 'error-reporter',
  enforce: 'pre',
  setup() {
    setBookingErrorReporter({ captureException, captureMessage })
  },
})
